// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ESHOP_BANNER_TEXT = "Ko\u010d\u00edky a autoseda\u010dky";
export const PREGNANCY_NEWSLETTER_BANNER_TEXT = "Odoberaj tehotensk\u00fd newsletter! ";
export const PREGNANCY_NEWSLETTER_HINT = "Si tehotn\u00e1?";
export const PRODUCT_ESHOP_BADGE = "Mamaleto E-shop";
